export enum PASS_FAIL {
  PASS = 'PASS',
  FAIL = 'FAIL'
};
